export default [
    {
        id: 1,
        title: "YouTube",
        coverImg: "youtube.webp",
        route: "youtube",

    },
    {
        id: 2,
        title: "Gmail",
        coverImg: "gmail.webp",
        route: "gmail",
    },
    {
        id: 3,
        title: "Google Maps",
        coverImg: "maps.webp",
        route: "googlemaps",
    },
]